import {
  Dialog,
  FlatButton,
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from "material-ui";
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { checkJapanese, checkMobile, isIpadOS } from "../../lib";
import DialogTitle from "../Shared/DialogTitle";
import { tdStyle } from "./QuestionnaireTable";
import { CSVLink } from "react-csv";

const jpCSVFieldsNames = ['タイトル', '質問', '匿名', '選択肢'];
const enCSVFieldsNames = ['Title', 'Question', 'Anonymous', 'Select'];

class QuestionnaireResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resultCsvData: []
    }
  }

  componentDidMount() {
    if(this.props && this.props.selectedResult) {
      this.setResultCsvData();
    }
  }

  setResultCsvData = () => {
    // Gets the basic fields of the CSV
    let fieldNames = checkJapanese() ? jpCSVFieldsNames : enCSVFieldsNames;

    // Gets the options fields of the CSV
    let options = this.props.selectedResult.options.map((option, index) => {
      return checkJapanese() ? [`回答${index + 1}`, `ユーザ(回答${index+ 1})`] : [`Option${index + 1}`, `User(Option${index + 1})`];
    });
    options = Array.prototype.concat.apply([], options);

    // Merge the options with the other fields
    fieldNames = fieldNames.concat(options)
    fieldNames.push(checkJapanese() ? '自由記述' : 'Description');
    // fieldNames.push(this.getAnswers());
    this.setState({ resultCsvData: [fieldNames, this.getAnswers()] });
  }

  getAnswers = () => {
    const question = this.props.selectedResult;
    const isAnonymousNotAllowed = question.last_anonymous_state && question.last_anonymous_state === "無";
    const anonymous = this.props.intl.formatMessage({ id: "questionnaire.anonymous" });
    let basicFieldData = [
      question.title, 
      question.question, 
      question.anonymous === 'yes' 
        ? checkJapanese() ? '有' : 'Allowed' 
        : checkJapanese() ? '無' : 'Not Allowed',
      question.choices === 'single'
        ? checkJapanese() ? '１つのみ選択' : 'Only one' 
        : checkJapanese() ? '複数選択' : 'Multiple' 
    ];

    let optionsData = question.options.map(option => {
      return [option.value, this.getResponders(option.id, true)]
    })

    optionsData = Array.prototype.concat.apply([], optionsData);
    basicFieldData = basicFieldData.concat(optionsData);

    let descriptions = question.answers.filter(q => q.description).map((a, index) => `${a.description} ${isAnonymousNotAllowed
      ? `(${a.name})`
      : `(${anonymous + (checkJapanese() ? "" : " " )+ (index + 1)})`
    }`).join(', \n')
    basicFieldData.push(descriptions);
    return basicFieldData;
  }

  getAnswerCount = (answer) => {
    return this.props.selectedResult.answers.filter((ans) =>
      ans.answer.find((a) => a.id === answer)
    ).length;
  };

  getResponders = (answer, count = false) => {
    let answers = this.props.selectedResult.answers
    .filter((ans) => ans.answer.find((a) => a.id === answer))
    if (this.props.selectedResult.last_anonymous_state === "有") {
      return count ? answers.length : "";
    } else {
      return answers
        .map((u) => u.name)
        .join(", ");
    }
  };

  getTotalAnswerCount = () => {
    return this.props.selectedResult.answers.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.from === value.from)
    ).length;
  };

  getAnonymousType() {
    if(this.props.selectedResult.last_anonymous_state) {
      return this.props.selectedResult.last_anonymous_state === "有" ? "yes" : "no"
    } else {
      return this.props.selectedResult.anonymous
    }
  }

  render() {
    let options = this.props.selectedResult.options;
    const isAnonymousNotAllowed = this.props.selectedResult.last_anonymous_state && this.props.selectedResult.last_anonymous_state === "無";
    const anonymous = this.props.intl.formatMessage({ id: "questionnaire.anonymous" });
    return (
      <Dialog
        modal={false}
        title={
          <DialogTitle
            heading={
              <FormattedMessage id="questionnaire.questionnaireResult" />
            }
            handleClose={this.props.handleClose}
          />
        }
        open={this.props.open}
        onRequestClose={this.props.handleClose}
        contentClassName="popup-modal-content"
        contentStyle={{ maxWidth: "700px", width: "96%" }}
        bodyStyle={{ padding: 0 }}
        autoScrollBodyContent={true}
        className="popup-modal"
        bodyClassName="popup-modal-body"
      >
        <div
          style={{
            backgroundColor: "rgb(241, 241, 241)",
            padding: "20px 30px",
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              minHeight: "48px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#657285",
              marginTop: "1.5rem",
              color: "#fff",
              padding: "4px"
            }}
          >
            {this.props.selectedResult.title}
          </div>

          <div
            style={{
              marginTop: "1.5rem",
              fontSize: "14px",
              color: "#657285",
            }}
          >
            {this.props.selectedResult.question} (
            {this.props.selectedResult.choices === "single" ? (
              <FormattedMessage id="questionnaire.one" />
            ) : (
              <FormattedMessage id="questionnaire.multiple" />
            )}
            )
          </div>

          <Table
            selectable={false}
            selectedColor="black"
            // height={"70vh"}
            bodyStyle={{
              display: "contents",
            }}
            style={{
              border: "1px solid #b8b8b8",
              marginTop: "8px",
              minWidth: "612px",
            }}
          >
            {options.length > 0 && (
              <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
                <TableRow
                  style={{
                    border: "1px solid #b8b8b8",
                    backgroundColor: "#6B7c93",
                    color: "#fff",
                  }}
                >
                  <TableRowColumn colSpan={isAnonymousNotAllowed ? 2 : 5} style={{ ...tdStyle, color: "#fff" }}>
                    <FormattedMessage id="questionnaire.options" />
                  </TableRowColumn>
                  {isAnonymousNotAllowed && 
                    <TableRowColumn
                      colSpan={2}
                      style={{ ...tdStyle, color: "#fff" }}
                    >
                      <FormattedMessage id="questionnaire.responder" />
                    </TableRowColumn>
                  }
                  <TableRowColumn style={{ ...tdStyle, color: "#fff" }}>
                    <FormattedMessage id="questionnaire.number" />
                  </TableRowColumn>
                </TableRow>

                {options.map((option, index) => {
                  return (
                    <TableRow
                      key={index}
                      selected={false}
                      className={index % 2 == 0 ? "dark-row" : "light-row"}
                      style={{
                        backgroundColor: "#f2f3f6",
                        borderBottom: "1px solid #b8b8b8",
                      }}
                    >
                      <TableRowColumn colSpan={isAnonymousNotAllowed ? 2 : 5} style={tdStyle}>
                        {option.value}
                      </TableRowColumn>
                     {isAnonymousNotAllowed && 
                        <TableRowColumn colSpan={2} style={tdStyle}>
                          {this.getResponders(option.id)}
                        </TableRowColumn>
                      }
                      <TableRowColumn style={tdStyle}>
                        {this.getAnswerCount(option.id)}
                      </TableRowColumn>
                    </TableRow>
                  );
                })}
              </TableBody>
            )}
          </Table>

          <div
            style={{
              backgroundColor: "#e9e9eb",
              padding: "14px",
              margin: "4px 0",
              textAlign: "center",
              color: "#6B7c93",
            }}
          >
            <FormattedMessage id='questionnaire.totalAnswers' values={{number: this.getTotalAnswerCount()}}/>
          </div>

          <div style={{ color: "#6B7c93", margin: "16px 0", fontSize: '14px' }}>
            <FormattedMessage id="questionnaire.anonymous" />
            <span style={{ marginLeft: "10px" }}>
              <FormattedMessage
                id={this.getAnonymousType() === "yes" ? "questionnaire.allowed" : "questionnaire.notAllowed"}
              />
            </span>
          </div>

          {this.props.selectedResult.free_description && (
            <div
              style={{
                backgroundColor: "#fff",
                padding: "16px",
                border: "1px solid #b8b8b8",
                color: "#6B7c93",
                fontSize: "14px",
                fontWeight: "bold",
                wordBreak: "break-all",
              }}
            >
              <FormattedMessage id="questionnaire.freeDescription" />
              {this.props.selectedResult.answers.map((a, index) => {
                if(a.description) {
                  return <div style={{ fontWeight: "normal", margin: '0 0 10px 0'}} key={a.from}>
                    <span style={{ whiteSpace: 'pre-wrap' }}>
                      {a.description}{" "}
                      {isAnonymousNotAllowed
                        ? `(${a.name})`
                        : `(${anonymous + (checkJapanese() ? "" : " " )+ (index + 1)})`
                      }
                    </span>
                    <br />
                  </div>
                }
              })}
            </div>
          )}

          {!checkMobile() && !isIpadOS() && <div style={{ textAlign: "center", margin: "10px 0" }}>
          <CSVLink data={this.state.resultCsvData} filename={checkJapanese() ? 'CSV出力 JP.csv' : 'CSV export EN.csv'} >
            <FlatButton
              label={<FormattedMessage id="questionnaire.csvExport" />}
              backgroundColor="#60d1bd"
              hoverColor="#60d1bd"
              style={{
                boxShadow: "none",
                height: "40px",
                lineHeight: "40px",
                minWidth: "160px",
                borderRadius: "5px",
                margin: "auto",
              }}
              labelStyle={{
                color: "#fff",
              }}
            />
          </CSVLink>
          </div>}
        </div>
      </Dialog>
    );
  }
}

export default injectIntl(QuestionnaireResult);



// WEBPACK FOOTER //
// src/components/Questionnaire/QuestionnaireResult.js